var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container-template-component"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("容器名称")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("容器名称"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption,
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }, _vm._l(_vm.nameOptions, function (item) {
    return _c("a-select-option", {
      key: item,
      attrs: {
        value: item
      }
    }, [_vm._v(_vm._s(_vm.$t(item)))]);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("容器标识")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("容器标识"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption,
      allowClear: ""
    },
    model: {
      value: _vm.form.mark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mark", $$v);
      },
      expression: "form.mark"
    }
  }, _vm._l(_vm.markOptions, function (item) {
    return _c("a-select-option", {
      key: item,
      attrs: {
        value: item
      }
    }, [_vm._v(_vm._s(_vm.$t(item)))]);
  }), 1)], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: function ($event) {
        return _vm.searchContainer();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1)], 1), _c("div", {
    staticClass: "btn-box"
  }, [_vm.isAuth("home.containerTemplateStore") ? _c("a-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.newContainer
    }
  }, [_vm._v(_vm._s(_vm.$t("新建容器")))]) : _vm._e()], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record) {
        return [record.status == 1 && _vm.isAuth("home.containerTemplateEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.editTemplate(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e()];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.changeStatus(record);
            }
          }
        })];
      }
    }, {
      key: "type",
      fn: function (text) {
        return [_c("span", [_vm._v(_vm._s(_vm.$t(text)))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("a-modal", {
    attrs: {
      visible: _vm.visible,
      title: _vm.$t("信息提示"),
      cancelButtonProps: {
        style: {
          display: "none"
        }
      },
      wrapClassName: "disable-modal-class"
    },
    on: {
      ok: function ($event) {
        _vm.visible = false;
      },
      cancel: function ($event) {
        _vm.visible = false;
      }
    }
  }, [_c("div", {
    staticClass: "disabled-title"
  }, [_c("a-icon", {
    style: {
      fontSize: "20px"
    },
    attrs: {
      type: "info-circle",
      theme: "twoTone"
    }
  }), _c("span", {
    staticClass: "line-text"
  }, [_vm._v(_vm._s(_vm.$t("无法禁用")))])], 1), _c("p", [_vm._v(_vm._s(_vm.$t("当前容器模板在以下 文件模板/发布客户中使用，请禁用发布数据后操作")))]), _vm._l(_vm.fileTemplateInfo, function (item) {
    return _c("p", {
      key: item.id,
      staticClass: "file-template"
    }, [_vm._v(_vm._s(item.name + "/" + item.id))]);
  }), _vm._l(_vm.customerInfo, function (item) {
    return _c("p", {
      key: item.customerName,
      staticClass: "file-template"
    }, [_vm._v(" " + _vm._s(item.customerName + "/" + item.applicationName + "&" + item.type) + " ")]);
  })], 2), _c("a-modal", {
    attrs: {
      visible: _vm.containerVisible,
      title: _vm.$t("新建容器"),
      width: 600
    },
    on: {
      ok: _vm.newContainerOk,
      cancel: function ($event) {
        _vm.containerVisible = false;
      }
    }
  }, [_c("a-form-model", {
    ref: "containerForm",
    attrs: {
      model: _vm.containerForm,
      "label-col": {
        span: 8
      },
      rules: _vm.containerRules,
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      "label-col": {
        span: 6
      },
      label: _vm.$t("容器分类")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("容器分类")
    },
    model: {
      value: _vm.containerForm.type,
      callback: function ($$v) {
        _vm.$set(_vm.containerForm, "type", $$v);
      },
      expression: "containerForm.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "table"
    }
  }, [_vm._v(_vm._s(_vm.$t("数据表格")))])], 1)], 1)], 1)], 1), _c("a-row", [_c("div", {
    staticClass: "table-sort-select-box"
  }, [_c("div", {
    class: ["table-sort-item", _vm.containerForm.tableType === "increment" ? "current-active-class" : ""],
    attrs: {
      KEY: "increment"
    },
    on: {
      click: function ($event) {
        return _vm.changeTableType("increment");
      }
    }
  }, [_c("div", {
    staticClass: "icon-part"
  }, [_c("svg-icon", {
    attrs: {
      icon: "increTable",
      size: 44
    }
  })], 1), _c("div", {
    staticClass: "desc"
  }, [_c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("主要应用于具有收集数据的需求，但对填写者会填写多少条数据，存在不确定的情况，此时就可使用自增表格。")) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2), _vm._v(" " + _vm._s(_vm.$t("自增表格")) + " ")], 1)])])]), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("列"),
      prop: "columnNum"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      precision: 0,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("列数")
    },
    model: {
      value: _vm.containerForm.columnNum,
      callback: function ($$v) {
        _vm.$set(_vm.containerForm, "columnNum", $$v);
      },
      expression: "containerForm.columnNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("行"),
      prop: "rowNum"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      precision: 0,
      min: _vm.containerForm.tableType === "increment" ? 1 : 2,
      max: 50,
      disabled: _vm.containerForm.tableType === "increment",
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("行数")
    },
    model: {
      value: _vm.containerForm.rowNum,
      callback: function ($$v) {
        _vm.$set(_vm.containerForm, "rowNum", $$v);
      },
      expression: "containerForm.rowNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("前")) + " "), _c("a-input-number", {
    staticStyle: {
      width: "80px",
      "margin-left": "10px"
    },
    attrs: {
      precision: 0,
      min: 1,
      max: _vm.maxTabHeaderNum,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("列数")
    },
    model: {
      value: _vm.containerForm.tableHeaderRowNum,
      callback: function ($$v) {
        _vm.$set(_vm.containerForm, "tableHeaderRowNum", $$v);
      },
      expression: "containerForm.tableHeaderRowNum"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("行为表头行")) + " ")], 1)])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };